import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { saveLanguagePreference } from 'src/utils/languageDetector';

const SwitcherButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  font-size: 14px;
  font-weight: 600;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  &:focus {
    outline: 2px solid rgba(255, 255, 255, 0.5);
  }
`;

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'vi' : 'en';
    i18n.changeLanguage(newLang);
    saveLanguagePreference(newLang);
  };

  // Safely get language with fallback for SSR
  const currentLanguage = i18n.language || 'en';
  const displayLanguage = currentLanguage.toUpperCase();
  const nextLanguage = currentLanguage === 'en' ? 'Vietnamese' : 'English';

  return (
    <SwitcherButton
      onClick={toggleLanguage}
      aria-label={`Switch to ${nextLanguage}`}
      title={`Switch to ${nextLanguage}`}>
      {displayLanguage}
    </SwitcherButton>
  );
};

export default LanguageSwitcher;
